import type { SearchResultItemStory } from '../../../atoms/searchResults.js'
import { ResultCollection } from './ResultCollection.js'

type Props = {
  items: SearchResultItemStory[]
  onCloseSearchDialog: () => void
  navigationDisabled?: boolean
  activeItemId?: string
}

export function RecentResults(props: Props) {
  const { onCloseSearchDialog, navigationDisabled, items, activeItemId } = props

  return (
    <ResultCollection
      activeItemId={activeItemId}
      navigationDisabled={navigationDisabled}
      noResults="Recently selected search results will appear here."
      onCloseSearchDialog={onCloseSearchDialog}
      results={items}
      title="Recent"
      variant="recent"
    />
  )
}
